/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));
var _hasOwn = _interopRequireDefault(require("../../../packages/hasOwn"));
var _statics = _interopRequireDefault(require("./statics"));
var _eventemitter = _interopRequireDefault(require("eventemitter3"));
var _inherits = _interopRequireDefault(require("./inherits"));
var _validate = _interopRequireDefault(require("./validate"));
var objectToString = Object.prototype.toString;
var isObject = function isObject(value) {
  return objectToString.apply(value) === '[object Object]';
};
function copyList(source, target, list) {
  if (source) {
    list.forEach(function (key) {
      if ((0, _hasOwn.default)(source, key)) {
        target[key] = source[key];
      }
    });
  }
  return target;
}
var POINT_POSITIONS = {
  cy: 'YCenter',
  cx: 'XCenter',
  t: 'Top',
  tc: 'TopCenter',
  tl: 'TopLeft',
  tr: 'TopRight',
  b: 'Bottom',
  bc: 'BottomCenter',
  bl: 'BottomLeft',
  br: 'BottomRight',
  l: 'Left',
  lc: 'LeftCenter',
  r: 'Right',
  rc: 'RightCenter',
  c: 'Center'
};
var REGION = function REGION() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var top = args[0],
    right = args[1],
    bottom = args[2],
    left = args[3];
  if (!(this instanceof REGION)) {
    return (0, _construct2.default)(REGION, args);
  }
  _eventemitter.default.call(this);
  if (isObject(top)) {
    copyList(top, this, ['top', 'right', 'bottom', 'left']);
    if (top.bottom == null && top.height != null) {
      this.bottom = this.top + top.height;
    }
    if (top.right == null && top.width != null) {
      this.right = this.left + top.width;
    }
    if (this.right == null) {
      this.right = this.left;
    }
    if (this.bottom == null) {
      this.bottom = this.top;
    }
    if (top.emitChangeEvents) {
      this.emitChangeEvents = top.emitChangeEvents;
    }
  } else {
    this.top = top;
    this.right = right;
    this.bottom = bottom;
    this.left = left;
  }
  this[0] = this.left;
  this[1] = this.top;
  (0, _validate.default)(this);
};
(0, _inherits.default)(REGION, _eventemitter.default);
Object.assign(REGION.prototype, {
  emitChangeEvents: false,
  getRegion: function getRegion(clone) {
    return clone ? this.clone() : this;
  },
  setRegion: function setRegion(reg) {
    if (reg instanceof REGION) {
      this.set(reg.get());
    } else {
      this.set(reg);
    }
    return this;
  },
  validate: function validate() {
    return REGION.validate(this);
  },
  _before: function _before() {
    if (this.emitChangeEvents) {
      return copyList(this, {}, ['left', 'top', 'bottom', 'right']);
    }
  },
  _after: function _after(before) {
    if (this.emitChangeEvents) {
      if (this.top != before.top || this.left != before.left) {
        this.emitPositionChange();
      }
      if (this.right != before.right || this.bottom != before.bottom) {
        this.emitSizeChange();
      }
    }
  },
  notifyPositionChange: function notifyPositionChange() {
    this.emit('changeposition', this);
  },
  emitPositionChange: function emitPositionChange() {
    this.notifyPositionChange();
  },
  notifySizeChange: function notifySizeChange() {
    this.emit('changesize', this);
  },
  emitSizeChange: function emitSizeChange() {
    this.notifySizeChange();
  },
  add: function add(directions) {
    var before = this._before();
    var direction;
    for (direction in directions) if ((0, _hasOwn.default)(directions, direction)) {
      this[direction] += directions[direction];
    }
    this[0] = this.left;
    this[1] = this.top;
    this._after(before);
    return this;
  },
  substract: function substract(directions) {
    var before = this._before();
    var direction;
    for (direction in directions) if ((0, _hasOwn.default)(directions, direction)) {
      this[direction] -= directions[direction];
    }
    this[0] = this.left;
    this[1] = this.top;
    this._after(before);
    return this;
  },
  getSize: function getSize() {
    return {
      width: this.width,
      height: this.height
    };
  },
  setPosition: function setPosition(position) {
    var width = this.width;
    var height = this.height;
    if (position.left != undefined) {
      position.right = position.left + width;
    }
    if (position.top != undefined) {
      position.bottom = position.top + height;
    }
    return this.set(position);
  },
  setSize: function setSize(size) {
    if (size.height != undefined && size.width != undefined) {
      return this.set({
        right: this.left + size.width,
        bottom: this.top + size.height
      });
    }
    if (size.width != undefined) {
      this.setWidth(size.width);
    }
    if (size.height != undefined) {
      this.setHeight(size.height);
    }
    return this;
  },
  setWidth: function setWidth(width) {
    return this.set({
      right: this.left + width
    });
  },
  setHeight: function setHeight(height) {
    return this.set({
      bottom: this.top + height
    });
  },
  set: function set(directions) {
    var before = this._before();
    copyList(directions, this, ['left', 'top', 'bottom', 'right']);
    if (directions.bottom == null && directions.height != null) {
      this.bottom = this.top + directions.height;
    }
    if (directions.right == null && directions.width != null) {
      this.right = this.left + directions.width;
    }
    this[0] = this.left;
    this[1] = this.top;
    this._after(before);
    return this;
  },
  get: function get(dir) {
    return dir ? this[dir] : copyList(this, {}, ['left', 'right', 'top', 'bottom']);
  },
  shift: function shift(directions) {
    var before = this._before();
    if (directions.top) {
      this.top += directions.top;
      this.bottom += directions.top;
    }
    if (directions.left) {
      this.left += directions.left;
      this.right += directions.left;
    }
    this[0] = this.left;
    this[1] = this.top;
    this._after(before);
    return this;
  },
  unshift: function unshift(directions) {
    if (directions.top) {
      directions.top *= -1;
    }
    if (directions.left) {
      directions.left *= -1;
    }
    return this.shift(directions);
  },
  equals: function equals(region) {
    return this.equalsPosition(region) && this.equalsSize(region);
  },
  equalsSize: function equalsSize(size) {
    var isInstance = size instanceof REGION;
    var s = {
      width: size.width == null && isInstance ? size.getWidth() : size.width,
      height: size.height == null && isInstance ? size.getHeight() : size.height
    };
    return this.getWidth() == s.width && this.getHeight() == s.height;
  },
  equalsPosition: function equalsPosition(region) {
    return this.top == region.top && this.left == region.left;
  },
  addLeft: function addLeft(left) {
    var before = this._before();
    this.left = this[0] = this.left + left;
    this._after(before);
    return this;
  },
  addTop: function addTop(top) {
    var before = this._before();
    this.top = this[1] = this.top + top;
    this._after(before);
    return this;
  },
  addBottom: function addBottom(bottom) {
    var before = this._before();
    this.bottom += bottom;
    this._after(before);
    return this;
  },
  addRight: function addRight(right) {
    var before = this._before();
    this.right += right;
    this._after(before);
    return this;
  },
  minTop: function minTop() {
    return this.expand({
      top: 1
    });
  },
  maxBottom: function maxBottom() {
    return this.expand({
      bottom: 1
    });
  },
  minLeft: function minLeft() {
    return this.expand({
      left: 1
    });
  },
  maxRight: function maxRight() {
    return this.expand({
      right: 1
    });
  },
  expand: function expand(directions, region) {
    var docRegion = region || REGION.getDocRegion();
    var list = [];
    var direction;
    var before = this._before();
    for (direction in directions) if ((0, _hasOwn.default)(directions, direction)) {
      list.push(direction);
    }
    copyList(docRegion, this, list);
    this[0] = this.left;
    this[1] = this.top;
    this._after(before);
    return this;
  },
  clone: function clone() {
    return new REGION({
      top: this.top,
      left: this.left,
      right: this.right,
      bottom: this.bottom
    });
  },
  containsPoint: function containsPoint(x, y) {
    if (arguments.length == 1) {
      y = x.y;
      x = x.x;
    }
    return this.left <= x && x <= this.right && this.top <= y && y <= this.bottom;
  },
  containsRegion: function containsRegion(region) {
    return this.containsPoint(region.left, region.top) && this.containsPoint(region.right, region.bottom);
  },
  diffHeight: function diffHeight(region) {
    return this.diff(region, {
      top: true,
      bottom: true
    });
  },
  diffWidth: function diffWidth(region) {
    return this.diff(region, {
      left: true,
      right: true
    });
  },
  diff: function diff(region, directions) {
    var result = {};
    var dirName;
    for (dirName in directions) if ((0, _hasOwn.default)(directions, dirName)) {
      result[dirName] = this[dirName] - region[dirName];
    }
    return result;
  },
  getPosition: function getPosition() {
    return {
      left: this.left,
      top: this.top
    };
  },
  getPoint: function getPoint(position, asLeftTop) {
    if (!POINT_POSITIONS[position]) {
      console.warn('The position ', position, ' could not be found! Available options are tl, bl, tr, br, l, r, t, b.');
    }
    var method = 'getPoint' + POINT_POSITIONS[position],
      result = this[method]();
    if (asLeftTop) {
      return {
        left: result.x,
        top: result.y
      };
    }
    return result;
  },
  getPointYCenter: function getPointYCenter() {
    return {
      x: null,
      y: this.top + this.getHeight() / 2
    };
  },
  getPointXCenter: function getPointXCenter() {
    return {
      x: this.left + this.getWidth() / 2,
      y: null
    };
  },
  getPointTop: function getPointTop() {
    return {
      x: null,
      y: this.top
    };
  },
  getPointTopCenter: function getPointTopCenter() {
    return {
      x: this.left + this.getWidth() / 2,
      y: this.top
    };
  },
  getPointTopLeft: function getPointTopLeft() {
    return {
      x: this.left,
      y: this.top
    };
  },
  getPointTopRight: function getPointTopRight() {
    return {
      x: this.right,
      y: this.top
    };
  },
  getPointBottom: function getPointBottom() {
    return {
      x: null,
      y: this.bottom
    };
  },
  getPointBottomCenter: function getPointBottomCenter() {
    return {
      x: this.left + this.getWidth() / 2,
      y: this.bottom
    };
  },
  getPointBottomLeft: function getPointBottomLeft() {
    return {
      x: this.left,
      y: this.bottom
    };
  },
  getPointBottomRight: function getPointBottomRight() {
    return {
      x: this.right,
      y: this.bottom
    };
  },
  getPointLeft: function getPointLeft() {
    return {
      x: this.left,
      y: null
    };
  },
  getPointLeftCenter: function getPointLeftCenter() {
    return {
      x: this.left,
      y: this.top + this.getHeight() / 2
    };
  },
  getPointRight: function getPointRight() {
    return {
      x: this.right,
      y: null
    };
  },
  getPointRightCenter: function getPointRightCenter() {
    return {
      x: this.right,
      y: this.top + this.getHeight() / 2
    };
  },
  getPointCenter: function getPointCenter() {
    return {
      x: this.left + this.getWidth() / 2,
      y: this.top + this.getHeight() / 2
    };
  },
  getHeight: function getHeight() {
    return this.bottom - this.top;
  },
  getWidth: function getWidth() {
    return this.right - this.left;
  },
  getTop: function getTop() {
    return this.top;
  },
  getLeft: function getLeft() {
    return this.left;
  },
  getBottom: function getBottom() {
    return this.bottom;
  },
  getRight: function getRight() {
    return this.right;
  },
  getArea: function getArea() {
    return this.getWidth() * this.getHeight();
  },
  constrainTo: function constrainTo(contrain) {
    var intersect = this.getIntersection(contrain);
    var shift;
    if (!intersect || !intersect.equals(this)) {
      var contrainWidth = contrain.getWidth(),
        contrainHeight = contrain.getHeight();
      if (this.getWidth() > contrainWidth) {
        this.left = contrain.left;
        this.setWidth(contrainWidth);
      }
      if (this.getHeight() > contrainHeight) {
        this.top = contrain.top;
        this.setHeight(contrainHeight);
      }
      shift = {};
      if (this.right > contrain.right) {
        shift.left = contrain.right - this.right;
      }
      if (this.bottom > contrain.bottom) {
        shift.top = contrain.bottom - this.bottom;
      }
      if (this.left < contrain.left) {
        shift.left = contrain.left - this.left;
      }
      if (this.top < contrain.top) {
        shift.top = contrain.top - this.top;
      }
      this.shift(shift);
      return true;
    }
    return false;
  },
  __IS_REGION: true
});
Object.defineProperties(REGION.prototype, {
  width: {
    get: function get() {
      return this.getWidth();
    },
    set: function set(width) {
      return this.setWidth(width);
    }
  },
  height: {
    get: function get() {
      return this.getHeight();
    },
    set: function set(height) {
      return this.setHeight(height);
    }
  }
});
(0, _statics.default)(REGION);
var _default = REGION;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/region/src/index.js
// module id = 771
// module chunks = 0